(() => {
  const endpoint = 'https://srocevkpcumehftvojhh.supabase.co/functions/v1/rastrear-pedido';
  const whatsappNumber = '525548780435';
  const statusLabels = {
    registrada: 'Pedido confirmado',
    en_produccion: 'En producción',
    lista: 'Pedido listo',
    entregada: 'Entregado',
    cancelada: 'Pedido cancelado',
  };
  const statusPositions = {
    registrada: 0,
    en_produccion: 1,
    lista: 2,
    entregada: 3,
  };
  const statusDescriptions = {
    registrada: 'Hemos recibido tu pedido y está confirmado.',
    en_produccion: 'Tu pedido se encuentra actualmente en producción.',
  };
  const monthNames = [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
  ];

  const formatCalendarDate = (value) => {
    const match = typeof value === 'string' && value.match(/^(\d{4})-(\d{2})-(\d{2})$/);

    if (!match) return null;

    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const date = new Date(Date.UTC(year, month - 1, day));

    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null;

    return `${day} de ${monthNames[month - 1]} de ${year}`;
  };

  const getErrorMessage = (response, payload) => {
    if (response.status === 404 || payload?.codigo === 'NO_ENCONTRADO' || payload?.code === 'NO_ENCONTRADO') {
      return 'No encontramos un pedido con esos datos. Revisa tu folio y los últimos 4 dígitos de tu teléfono.';
    }

    if (response.status === 429 || payload?.codigo === 'DEMASIADOS_INTENTOS' || payload?.code === 'DEMASIADOS_INTENTOS') {
      return 'Has realizado varios intentos. Intenta nuevamente más tarde.';
    }

    if (response.status === 400) return 'Revisa el folio y los últimos 4 dígitos de tu teléfono.';

    return 'No pudimos consultar tu pedido en este momento. Intenta nuevamente más tarde.';
  };

  const getStatusDescription = (status, fulfillment, hasPendingDate) => {
    if (status === 'cancelada') return 'Este pedido aparece como cancelado.';

    if (hasPendingDate) {
      return 'Tu pedido continúa avanzando. La fecha de entrega está pendiente de programación.';
    }

    if (status === 'lista') {
      return fulfillment === 'recoger'
        ? 'Tu pedido está listo para recoger.'
        : 'Tu pedido está listo y tiene una entrega programada.';
    }

    if (status === 'entregada') {
      return fulfillment === 'recoger' ? 'Tu pedido ya fue recogido.' : 'Tu pedido ya fue entregado.';
    }

    return statusDescriptions[status] || '';
  };

  const renderProducts = (itemsContainer, section, products) => {
    itemsContainer.replaceChildren();

    if (!Array.isArray(products) || products.length === 0) {
      section.hidden = true;
      return;
    }

    products.forEach((product) => {
      if (!product || typeof product.nombre !== 'string' || !product.nombre.trim()) return;

      const quantity = Number(product.cantidad);
      const count = Number.isFinite(quantity) && quantity > 1 ? quantity : 1;
      const item = document.createElement('li');
      const name = document.createElement('p');
      const quantityLabel = document.createElement('p');

      name.className = 'rastrear-pedido__item-name';
      name.textContent = product.nombre;
      quantityLabel.className = 'rastrear-pedido__item-quantity';
      quantityLabel.textContent = `${count} ${count === 1 ? 'pieza' : 'piezas'}`;
      item.append(name, quantityLabel);
      itemsContainer.append(item);
    });

    section.hidden = !itemsContainer.children.length;
  };

  const getFirstName = (value) => {
    if (typeof value !== 'string') return '';

    return value.trim().split(/\s+/)[0] || '';
  };

  const setStepStates = (result, status, fulfillment) => {
    const activePosition = statusPositions[status];

    result.querySelectorAll('[data-tracking-flow]').forEach((flow) => {
      const isActiveFlow = flow.dataset.trackingFlow === fulfillment;
      flow.hidden = !isActiveFlow || fulfillment === 'pendiente' || status === 'cancelada';

      if (!isActiveFlow || activePosition === undefined) return;

      flow.querySelectorAll('[data-tracking-step]').forEach((step, index) => {
        const isCurrent = index === activePosition;
        const isComplete = index < activePosition || (status === 'entregada' && isCurrent);

        step.classList.toggle('is-complete', isComplete);
        step.classList.toggle('is-current', isCurrent);

        if (isCurrent) {
          step.setAttribute('aria-current', 'step');
        } else {
          step.removeAttribute('aria-current');
        }
      });
    });
  };

  const initializeTracking = () => {
    const form = document.querySelector('[data-tracking-form]');
    const result = document.querySelector('[data-tracking-result]');

    if (!form || !result) return;

    const folioInput = form.querySelector('[data-tracking-folio-input]');
    const phoneInput = form.querySelector('[data-tracking-phone-input]');
    const submitButton = form.querySelector('[data-tracking-submit]');
    const submitLabel = form.querySelector('[data-tracking-submit-label]');
    const formMessage = form.querySelector('[data-tracking-form-message]');
    const folioOutput = result.querySelector('[data-tracking-folio]');
    const greetingOutput = result.querySelector('[data-tracking-greeting]');
    const statusOutput = result.querySelector('[data-tracking-status-label]');
    const messageOutput = result.querySelector('[data-tracking-message]');
    const orderSection = result.querySelector('[data-tracking-order-section]');
    const itemsContainer = result.querySelector('[data-tracking-items]');
    const orderDateDetail = result.querySelector('[data-tracking-detail="order-date"]');
    const orderDateOutput = result.querySelector('[data-tracking-order-date]');
    const fulfillmentDetail = result.querySelector('[data-tracking-detail="fulfillment"]');
    const fulfillmentOutput = result.querySelector('[data-tracking-fulfillment-label]');
    const deliveryDateDetail = result.querySelector('[data-tracking-detail="delivery-date"]');
    const deliveryDateOutput = result.querySelector('[data-tracking-delivery-date]');
    const deliveryZoneDetail = result.querySelector('[data-tracking-detail="delivery-zone"]');
    const deliveryZoneOutput = result.querySelector('[data-tracking-delivery-zone]');
    const helpSection = result.querySelector('[data-tracking-help]');
    const whatsappLink = result.querySelector('[data-tracking-whatsapp]');

    const showFormMessage = (message) => {
      formMessage.textContent = message;
      formMessage.hidden = false;
    };

    const clearFormMessage = () => {
      formMessage.textContent = '';
      formMessage.hidden = true;
    };

    const setLoading = (isLoading) => {
      submitButton.disabled = isLoading;
      submitButton.classList.toggle('is-loading', isLoading);
      submitLabel.textContent = isLoading ? 'Consultando...' : 'Consultar pedido';
    };

    const showResult = (order) => {
      const status = order.estado_codigo;
      const fulfillment = order.tipo_entrega;
      const isCancelled = status === 'cancelada';
      const isPendingFulfillment = fulfillment === 'pendiente';
      const formattedOrderDate = formatCalendarDate(order.fecha_pedido);
      const formattedDate = formatCalendarDate(order.fecha_entrega);
      const hasPendingDate = order.situacion_fecha_entrega === 'pendiente' || !formattedDate;
      const municipality = typeof order.zona_entrega?.alcaldia_municipio === 'string' ? order.zona_entrega.alcaldia_municipio : '';
      const state = typeof order.zona_entrega?.estado === 'string' ? order.zona_entrega.estado : '';
      const firstName = getFirstName(order.primer_nombre);

      if (!statusLabels[status] || !['domicilio', 'recoger', 'pendiente'].includes(fulfillment)) {
        showFormMessage('No pudimos consultar tu pedido en este momento. Intenta nuevamente más tarde.');
        return;
      }

      folioOutput.textContent = order.folio;
      greetingOutput.textContent = firstName ? `Hola, ${firstName}` : '';
      greetingOutput.hidden = !firstName;
      statusOutput.textContent = isPendingFulfillment && statusLabels[status] ? statusLabels[status] : order.estado_publico || statusLabels[status];
      messageOutput.textContent = getStatusDescription(status, fulfillment, hasPendingDate);
      renderProducts(itemsContainer, orderSection, order.productos);
      orderDateDetail.hidden = !formattedOrderDate;
      orderDateOutput.textContent = formattedOrderDate || '';
      fulfillmentDetail.hidden = isPendingFulfillment;
      fulfillmentOutput.textContent = fulfillment === 'domicilio' ? 'Entrega a domicilio' : fulfillment === 'recoger' ? 'Recoger en tienda' : '';
      deliveryDateDetail.hidden = isCancelled;
      deliveryDateOutput.textContent = hasPendingDate ? 'Pendiente de programación' : formattedDate;
      deliveryZoneDetail.hidden = fulfillment !== 'domicilio' || !municipality;
      deliveryZoneOutput.textContent = state ? `${municipality}, ${state}` : municipality;
      whatsappLink.href = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(`Hola, tengo una duda sobre mi pedido ${order.folio}.`)}`;
      helpSection.hidden = false;
      result.dataset.trackingStatus = status;
      result.dataset.trackingFulfillment = fulfillment;
      setStepStates(result, status, fulfillment);
      result.hidden = false;
      result.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      clearFormMessage();
      result.hidden = true;

      const folio = folioInput.value.trim();
      const phoneLastFour = phoneInput.value.trim();

      if (!folio) {
        showFormMessage('Escribe el folio de tu pedido.');
        folioInput.focus();
        return;
      }

      if (!/^\d{4}$/.test(phoneLastFour)) {
        showFormMessage('Escribe exactamente los últimos 4 dígitos de tu teléfono.');
        phoneInput.focus();
        return;
      }

      setLoading(true);

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            folio: folio.toUpperCase(),
            telefono_ultimos4: phoneLastFour,
          }),
        });
        let payload = null;

        try {
          payload = await response.json();
        } catch (error) {
          payload = null;
        }

        if (!response.ok) {
          showFormMessage(getErrorMessage(response, payload));
          return;
        }

        showResult(payload || {});
      } catch (error) {
        showFormMessage('No pudimos consultar tu pedido en este momento. Intenta nuevamente más tarde.');
      } finally {
        setLoading(false);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTracking, { once: true });
  } else {
    initializeTracking();
  }
})();
